import { takeEvery, call, put } from 'redux-saga/effects'

import {
  updateInvitedUsers,
  errorInvitedUsers,
  INVITE_USERS_POST,
} from 'actions/invite-users'

function _postAccount({ create }, logError) {
  return function*(action) {
    try {
      const org = action.payload.orgslug
      const inviteUsersEndpoint = `/api/v2/org/${org}/users`

      const rolesMap = {
        Admin: 'admin',
        User: 'member',
      }

      const values = action.payload.invitedUsers
        .map(user => {
          return user.setIn(
            ['roles', 0, 'name'],
            rolesMap[user.getIn(['roles', 0, 'name'])]
          )
        })
        .toJS()

      const inviteUsersResult = yield call(create, inviteUsersEndpoint, {
        invitees: values,
      })
      yield put(
        updateInvitedUsers({
          data: inviteUsersResult,
        })
      )
    } catch (err) {
      yield call(logError, err)

      const data =
        err.status === 400 && err.responseText
          ? JSON.parse(err.responseText)
          : null

      yield put(
        errorInvitedUsers({
          error: true,
          data: data,
        })
      )
    }
  }
}

export const Test = {
  _postAccount,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchPostInviteUsers(api, error) {
  yield takeEvery(INVITE_USERS_POST, _postAccount(api, error))
}
